// TanStack Query client — single shared instance for the entire panel.
//
// Defaults reflect the operational reality of the panel:
// - Logs / metrics are real-time (separate WS streams), so we keep cached
//   query results "fresh" for 30s rather than refetching on every focus.
// - gcTime kept at 5 min so background tabs don't drop hot caches that the
//   user is about to come back to.
// - retry: 1 — one retry is usually enough for transient blips; more
//   would mask actual API/network problems we want surfaced via Sentry.
// - refetchOnWindowFocus: false — focus-refetching causes UI churn for
//   admin work where you tab between dashboards repeatedly.
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
